// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__14axZ","box":"WorkspacesBox_box__2G-u2","node":"WorkspacesBox_node__EvZYM"};